import appConfig from '@/config/app.config';
import store from '../../store';

const commonConfig = {
  client_id: appConfig.CLIENT_ID,
  client_secret: appConfig.SECRET_ID,
  scope: appConfig.SCOPE,
};

const axiosBaseConfig = {
  method: 'POST',
  url: '/oauth/token',
};

export const authTokenRequest = async (userData, axiosClient) => {
  const options = {
    ...axiosBaseConfig,
    params: {
      ...commonConfig,
      grant_type: 'password',
      ...userData,
    },

  };
  const { data } = await axiosClient(options);

  return data;
};

export const refreshTokenRequest = async (refreshToken, axiosClient) => {
  const options = {
    ...axiosBaseConfig,
    params: {
      ...commonConfig,
      grant_type: 'refresh_token',
      refresh_token: refreshToken,
    },
  };
  const { data } = await axiosClient(options);

  return data;
};

export const logout = async () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('userData');
  localStorage.removeItem('userAbility');
  await store.dispatch('RESET_ALL_STORE');
};
